var _g, _g2, _g3, _g4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBackpic2 = function SvgBackpic2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 51,
    viewBox: "0 0 146 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32741_39576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5435 45.0141C16.077 44.8712 16.3935 44.3228 16.2506 43.7894C16.1077 43.2559 15.5593 42.9393 15.0259 43.0822C14.4924 43.2252 14.1758 43.7735 14.3188 44.307C14.4617 44.8405 15.01 45.157 15.5435 45.0141Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2709 42.9435C23.8044 42.8006 24.121 42.2523 23.978 41.7188C23.8351 41.1853 23.2867 40.8687 22.7533 41.0117C22.2198 41.1546 21.9032 41.703 22.0462 42.2364C22.1891 42.7699 22.7375 43.0865 23.2709 42.9435Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15735 29.698L6.53809 28.7921C6.53809 28.7921 7.41019 30.4514 7.96899 31.5146C9.08556 33.6389 10.6191 36.5567 11.5188 38.2684C11.9537 39.0959 12.9029 39.51 13.8059 39.268L22.1002 37.0456C23.0057 36.803 23.6211 35.964 23.5806 35.0276L23.2523 27.4194",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2523 27.4195L8.28046 31.4312",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32741_39576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9067 28.986L66.0304 32.5215L59.9067 28.986ZM60.7039 22.3019C61.9546 26.9697 59.1845 31.7677 54.5167 33.0184C49.8489 34.2692 45.0509 31.4991 43.8002 26.8312C42.5494 22.1634 45.3195 17.3655 49.9874 16.1147C54.6552 14.864 59.4532 17.6341 60.7039 22.3019Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_32741_39576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8284 17.8066L81.3973 8.73364L90.4703 6.30256L100.331 11.9956C101.239 12.5196 101.55 13.6802 101.026 14.5879L96.2813 22.805C95.7573 23.7127 94.5967 24.0237 93.6891 23.4996L83.8284 17.8066Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3161 11.5734L86.2963 11.562",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_32741_39576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.104 2.50328C119.961 1.96982 120.277 1.42148 120.811 1.27853L138.198 -3.38021C138.731 -3.52315 139.279 -3.20656 139.422 -2.6731L142.01 6.98616C142.153 7.51964 141.837 8.06796 141.303 8.2109L123.917 12.8696C123.383 13.0126 122.835 12.696 122.692 12.1625L120.104 2.50328Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.575 6.67663C132.642 6.39075 133.275 5.29407 132.989 4.22714C132.703 3.16021 131.606 2.52704 130.539 2.81293C129.472 3.09881 128.839 4.19549 129.125 5.26242C129.411 6.32935 130.508 6.96252 131.575 6.67663Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.281 6.30899L125.262 6.29761",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.872 3.20328L136.853 3.19189",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32741_39576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.449036 27.3179) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32741_39576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(39.0861 16.9651) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_32741_39576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(77.7231 6.6123) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_32741_39576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(116.36 -3.74048) rotate(-15)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackpic2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backpic2.d6c30198.svg";
export { ForwardRef as ReactComponent };